/**
 * Kopfbereich einer Seite ohne Kachel, auf dem Seitenhintergrund über den Sections.
 *
 * Links der Überblick (Zeitstrahl, Statusstrahl …), vertikal mittig. Rechts hinter einer
 * senkrechten Linie ein Block mit der Hauptaktion der Seite und dem, was zu ihr gehört
 * (Kennzahl, Rückweg). Alles im rechten Block ist gleich breit: Die Breite gibt der breiteste
 * Inhalt vor, die übrigen ziehen sich auf sie; die Linie reicht über den ganzen Block.
 *
 * Vorbild: Seite "Nachweise" – in der Übersicht und im geöffneten Nachweis.
 */
import React from "react";
import { Box } from "@mui/material";
import { colors } from "../../styles/theme";

interface SeitenKopfProps {
  /** Der Überblick links; nimmt die übrige Breite */
  children: React.ReactNode;
  /** Der Block rechts, Element für Element untereinander; ohne ihn entfällt auch die Linie */
  aktionen?: React.ReactNode;
}

const SeitenKopf: React.FC<SeitenKopfProps> = ({ children, aktionen }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 4 }}>
    <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
    {aktionen && (
      <Box
        sx={{
          flexShrink: 0,
          // Ohne Knopf (Lesemodus) hält die Mindestbreite den Block trotzdem ruhig.
          minWidth: 200,
          pl: 4,
          borderLeft: `1px solid ${colors.border.divider}`,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        {aktionen}
      </Box>
    )}
  </Box>
);

export default SeitenKopf;
